import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/page", {
    params,
  });

const get = (id) => authApi.get(`/page/${id}`);

const create = ({
  title,
  titleTC,
  titleSC,
  slug,
  slugTC,
  slugSC,
  content,
  contentTC,
  contentSC,
  css,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
  status,
  schedulePublishedDate,
  publishedDate
}) =>
  authApi.post(`/page`, {
    title,
    titleTC,
    titleSC,
    slug,
    slugTC,
    slugSC,
    content,
    contentTC,
    contentSC,
    css,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
    status,
    schedulePublishedDate,
    publishedDate
  });

const update = ({
  id,
  title,
  titleTC,
  titleSC,
  slug,
  slugTC,
  slugSC,
  content,
  contentTC,
  contentSC,
  css,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
  status,
  schedulePublishedDate,
  publishedDate
}) =>
  authApi.put(`/page`, {
    id,
    title,
    titleTC,
    titleSC,
    slug,
    slugTC,
    slugSC,
    content,
    contentTC,
    contentSC,
    css,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
    status,
    schedulePublishedDate,
    publishedDate,
  });

export {
  getAll,
  get,
  create,
  update,
};
